/* eslint-disable complexity */
import {
    AnalyticsAttributesProvider,
    Column,
    Container,
    Markdown,
    Row
} from "../../components";
import { UiFeatureSectionModel } from "../../models";
import { renderViewModel, renderViewModels } from "../../render-view-model";

import {
    TitlesContainer,
    Title,
    Eyebrow,
    HorizontalLine,
    BodyCopy,
    CTAs
} from "./UiFeatureSection.styles";
import { getVariantText, getVariantMedia } from "./variants";

export type UiFeatureSectionProps = {
    readonly model: UiFeatureSectionModel;
};

const UiFeatureSection = ({ model }: UiFeatureSectionProps) => {
    const {
        entryTitle,
        appearance,
        title,
        eyebrow,
        horizontalRule,
        bodyCopy,
        horizontalOrientation,
        verticalOrientation,
        media,
        callsToAction
    } = model.content;

    const verticalAlignment =
        verticalOrientation === "Image bottom" ? "bottom" : "top";

    return (
        <AnalyticsAttributesProvider
            value={{ eventColumn: title, labelEnglish: entryTitle }}
        >
            <Container>
                <Row verticalAlign={verticalAlignment}>
                    {media && (
                        <Column
                            md={getVariantMedia(
                                appearance,
                                horizontalOrientation,
                                verticalOrientation
                            )}
                            xs={
                                !appearance &&
                                verticalOrientation === "Image bottom"
                                    ? { order: "3" }
                                    : { order: "1" }
                            }
                        >
                            {renderViewModel(media)}
                        </Column>
                    )}
                    {appearance?.length === 5 && (
                        <Column md={{ order: "2", span: "1" }} />
                    )}
                    <Column
                        md={getVariantText(
                            appearance,
                            horizontalOrientation,
                            verticalOrientation
                        )}
                        xs={
                            !appearance &&
                            verticalOrientation === "Image bottom"
                                ? { order: "1" }
                                : { order: "3" }
                        }
                    >
                        {(title || eyebrow) && (
                            <TitlesContainer>
                                {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
                                {title && <Title>{title}</Title>}
                            </TitlesContainer>
                        )}
                        {horizontalRule && <HorizontalLine />}
                        {bodyCopy && (
                            <BodyCopy>
                                <Markdown>{bodyCopy}</Markdown>
                            </BodyCopy>
                        )}
                        {callsToAction && (
                            <CTAs appearance={appearance}>
                                {renderViewModels(callsToAction)}
                            </CTAs>
                        )}
                    </Column>
                </Row>
            </Container>
        </AnalyticsAttributesProvider>
    );
};

export default UiFeatureSection;
